var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { datasetsFetcher, purgeDataset, undeleteDataset } from "@/api/datasets";
import { archivedHistoriesFetcher, deleteHistory, historiesFetcher, undeleteHistory } from "@/api/histories";
const itemSizeSummaryFields = "id,name,size,deleted,archived";
export function fetchAllHistoriesSizeSummary() {
    return __awaiter(this, void 0, void 0, function* () {
        const nonPurgedHistoriesResponse = yield historiesFetcher({
            keys: itemSizeSummaryFields,
            q: ["deleted", "purged"],
            qv: ["None", "false"],
        });
        const nonPurgedArchivedHistories = yield archivedHistoriesFetcher({
            keys: itemSizeSummaryFields,
            q: ["purged"],
            qv: ["false"],
        });
        const allHistoriesTakingStorageResponse = [
            ...nonPurgedHistoriesResponse.data,
            ...nonPurgedArchivedHistories.data,
        ];
        return allHistoriesTakingStorageResponse;
    });
}
export function fetchHistoryContentsSizeSummary(historyId, limit = 5000, objectStoreId = null) {
    return __awaiter(this, void 0, void 0, function* () {
        const q = ["purged", "history_content_type"];
        const qv = ["false", "dataset"];
        if (objectStoreId) {
            q.push("object_store_id");
            qv.push(objectStoreId);
        }
        const response = yield datasetsFetcher({
            history_id: historyId,
            keys: itemSizeSummaryFields,
            limit,
            order: "size-dsc",
            q: q,
            qv: qv,
        });
        return response.data;
    });
}
export function fetchObjectStoreContentsSizeSummary(objectStoreId, limit = 5000) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield datasetsFetcher({
            keys: itemSizeSummaryFields,
            limit,
            order: "size-dsc",
            q: ["purged", "history_content_type", "object_store_id"],
            qv: ["false", "dataset", objectStoreId],
        });
        return response.data;
    });
}
export function undeleteHistoryById(historyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield undeleteHistory({ history_id: historyId });
        return response.data;
    });
}
export function purgeHistoryById(historyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield deleteHistory({ history_id: historyId, purge: true });
        return response.data;
    });
}
export function undeleteDatasetById(datasetId) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = yield undeleteDataset(datasetId);
        return data;
    });
}
export function purgeDatasetById(datasetId) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = yield purgeDataset(datasetId);
        return data;
    });
}
